import { ROUTES } from "../../enums/Route";

export const uploaderTransactionPages = [
  { label: "Disbursement History", value: ROUTES.REPORTS },
  { label: "Reprocess", value: ROUTES.REPROCESS },
];

export const transactionPages = [
  { label: "Disbursement History", value: ROUTES.REPORTS },
];

export const defaultBackgroundColor = "#C01217";

export const defaultHoverColor = "#e53e3e";
